// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-list a {\n  color: rgb(0, 70, 170) !important;\n  word-break: break-all;\n}\n.manufacturer-details label,\n  .manufacturer-details span {\n  margin: 0.8rem 0;\n  display: flex;\n}\n", ""]);
// Exports
module.exports = exports;
